import { Box } from '@mui/material'
import { FC, useContext, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { AppContext } from '../../providers/AppProvider/AppProvider'

export const AppHeaderSearchWithAutocomplete: FC = () => {
  const { featureFlags } = useContext(AppContext)
  const navigate = useNavigate()

  useEffect(() => {
    window.CommandBar.setFormFactor({
      type: 'inline',
      rootElement: document.querySelector(
        '#commandbar-inline-root'
      ) as HTMLElement
    })
    window.CommandBar.addRouter((route: any) => navigate(route))
  }, [navigate, featureFlags])

  return (
    <Box flexGrow={1} sx={{ height: '40px' }}>
      <div
        id="commandbar-inline-root"
        style={{ minWidth: '100px', maxWidth: '500px' }}></div>
    </Box>
  )
}
